"use strict";

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.object.entries.js");

require("core-js/modules/es.function.name.js");

var _ecc = require("../ecc");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var MultiSessionData =
/*#__PURE__*/
function () {
  function MultiSessionData(_ref) {
    var key = _ref.key,
        currentName = _ref.currentName,
        accounts = _ref.accounts;

    _classCallCheck(this, MultiSessionData);

    this.key = key;
    this.currentName = currentName;
    this.accounts = accounts;
  }

  _createClass(MultiSessionData, [{
    key: "getVal",
    value: function getVal(account, field) {
      var defaultVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      if (this.accounts[account]) return this.accounts[account][field] || defaultVal;
      return defaultVal;
    }
  }, {
    key: "setVal",
    value: function setVal(account, field, val) {
      this.accounts[account] = this.accounts[account] || {};
      this.accounts[account][field] = val;
      return this;
    }
  }, {
    key: "addKey",
    value: function addKey(account, authType, val) {
      if (val && val.toWif) val = val.toWif();

      try {
        _ecc.PrivateKey.fromWif(val);
      } catch (e) {
        val = _ecc.PrivateKey.fromSeed(account + authType + val).toString();
      }

      return this.setVal(account, authType, val);
    }
  }, {
    key: "addMultiAuth",
    value: function addMultiAuth(account) {
      return this.setVal(account, 'multiauth', true);
    }
  }, {
    key: "setCurrent",
    value: function setCurrent(account) {
      if (!this.accounts[account]) throw new Error('Cannot set current account to: ' + account + ' because it does not saved');
      this.currentName = account;
      return this;
    }
  }, {
    key: "logout",
    value: function logout(account) {
      var newCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      delete this.accounts[account];

      if (this.currentName === account) {
        this.currentName = '';

        if (newCurrent) {
          var arr = Object.entries(this.accounts);

          if (arr[0]) {
            this.currentName = arr[0][0];
            newCurrent.name = arr[0][0];
            newCurrent.data = arr[0][1];
          }
        }
      }

      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.accounts = {};
      this.currentName = '';
      return this;
    }
  }, {
    key: "save",
    value: function save() {
      var json = JSON.stringify({
        currentName: this.currentName,
        accounts: this.accounts
      });
      var buf = new Buffer(json).toString('hex');
      localStorage.setItem(this.key, buf);
      return this;
    }
  }]);

  return MultiSessionData;
}();

module.exports = MultiSessionData;